import react from "react";
import { Helmet } from 'react-helmet-async';

import print from './images/Prints/92_AUSTRIA_002 Large.jpeg'
import print1 from './images/Prints/40x28 on Hahnemuhle PhotoRag Baryta - Edition of 10- from Albow Gardens series.jpeg'
import print2 from './images/Prints/50x70 on Hahnemuhle PhotoRag Baryta - Edition of 15- From Khayelitsha series(1).jpeg'
import print3 from './images/Prints/50x70 on Hahnemuhle PhotoRag Baryta - Edition of 10-From Behind the bank series.jpeg'
import print4 from './images/Prints/50x70 on Hahnemuhle PhotoRag Baryta - Edition of 15- From Khayelitsha series.jpeg'
import print5 from './images/Prints/50x70 on Hahnemuhle PhotoRag Baryta - Edition of 15.jpeg'

const Prints = () => {
    return (
        <>
        <Helmet>
            <title>Fine Art Prints - Alessandro Iovino</title>
            <meta name="description" content="Limited edition fine art prints by Alessandro Iovino on Hahnemuhle PhotoRag Baryta paper. Inquire about available prints from various photography series." />
            <meta property="og:title" content="Fine Art Prints - Alessandro Iovino" />
            <meta property="og:description" content="Professional limited edition fine art photography prints" />
            <link rel="canonical" href="https://alessandroiovino.com/prints" />
        </Helmet>
        <div className="home-picture-gallery">
            <h1 className="sr-only">Fine Art Prints</h1>
        <div className="prints-item">
                <img src={print} alt="Fine art photography print sample on Hahnemuhle PhotoRag Baryta"/>
            </div>
                <br />
                <p className="print">For general inquiries and prints, please email alessandro.iovino88@gmail.com.</p>
                {/* <p className="print">For information on additional print options or any other inquiries, please contact me at alessandro.iovino88@gmail.com.</p> */}
            {/* <div className="thumbnail-grid">
                <div className="tg-item">
                    <img src={print1}/>
                    <p>40x28 on Hahnemuhle PhotoRag Baryta - from Albow Gardens series</p>
                </div>
                <div className="tg-item">
                    <img src={print5}/>
                    <p>50x70 on Hahnemuhle PhotoRag Baryta</p>
                </div>
                <div className="tg-item">
                    <img src={print2}/>
                    <p>50x70 on Hahnemuhle PhotoRag Baryta - From Khayelitsha series</p>
                </div>
                <div className="tg-item">
                    <img src={print3}/>
                    <p>50x70 on Hahnemuhle PhotoRag Baryta - From Behind the bank series</p>
                </div>
                <div className="tg-item">
                    <img src={print4}/>
                    <p>50x70 on Hahnemuhle PhotoRag Baryta - From Khayelitsha series</p>
                </div>
            </div> */}
           
        </div>
        </>
    );
}

export default Prints;